






























import { Component, Vue } from "vue-property-decorator";
import Header from "@/components/Header.vue";
import Menu from "@/components/Menu.vue";
import NextPrevBtn from "@/components/NextPrevBtn.vue";
import Footer from "@/components/Footer.vue";
@Component({
  components: {
    Header,
    Menu,
    NextPrevBtn,
    Footer,
  },
})
export default class ArtPerfOrigin extends Vue {
  protected nxtprevArtPerfOrigin = {
    BoolPrev: true,
    BoolNext: true,
    PrevImage: "/thumbnail5.png",
    NextImage: "/thumbnail1.png",
    PrevLink: "/PerformanceArtistique/Definition",
    NextLink: "/PerformanceArtistique/ExemplesEtudiants",
  };
}
